import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ProjectDefaultTodoService {
  getTodos: Subject<any> = new Subject();
  todos = [];
}
